import React from 'react'

import s from './styles.module.scss'

import { IconSvg } from '../../../components/atoms'

export const EmptyEditImage = () => {
  return (
    <div className={s.container}>
      <IconSvg.IconAddPicture opacity={0.25} />
    </div>
  )
}
